import { render, staticRenderFns } from "./FMark.vue?vue&type=template&id=650763d7&"
import script from "./FMark.vue?vue&type=script&lang=js&"
export * from "./FMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports